/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import {
  ExtensionTopicsGetOptionalParams,
  ExtensionTopicsGetResponse,
} from "../models/index.js";

/** Interface representing a ExtensionTopics. */
export interface ExtensionTopics {
  /**
   * Get the properties of an extension topic.
   * @param scope The identifier of the resource to which extension topic is queried. The scope can be a
   *              subscription, or a resource group, or a top level resource belonging to a resource provider
   *              namespace. For example, use '/subscriptions/{subscriptionId}/' for a subscription,
   *              '/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}' for a resource group, and
   *              '/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/{resourceProviderNamespace}/{resourceType}/{resourceName}'
   *              for Azure resource.
   * @param options The options parameters.
   */
  get(
    scope: string,
    options?: ExtensionTopicsGetOptionalParams,
  ): Promise<ExtensionTopicsGetResponse>;
}
